<template>  
   <div  ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">        
    <template v-if="graphType.length > 0">            
      <div style="flex:1 0 auto;position:relative;" class="mr-4 mt-2">
   <Responsive :breakpoints="{
    small: el => el.width <= 420
  }">
  <v-layout slot-scope="el"  class="scrollable-container"  ref="detail" mt-2 px-4 row wrap>          
    <v-flex v-for="g in graphType" style="position:relative;" class="px-2 flex-grow-0" :class="{sm12:el.is.small,sm6:!el.is.small}" :key="g">
        <!-- <v-btn icon @click="selectGraph(g)" small style="position:absolute;top:-7px;left:-2px;z-index:1"><v-icon>mdi-magnify-plus</v-icon></v-btn>         -->
        <div class="graphnmea mb-2">                       
          <bar-chart @onPointClick="onPointClick" v-if="!hideGraph && graphData(g)"
            :chart-data="graphData(g)"
            :options="{
                        animation:{duration:0},
                        legend:{display:true,labels:{fontColor:'#000',boxWidth:15,fontSize:11} },
                        responsive: true, 
                        maintainAspectRatio: false                        
                      }"
            :width="300"            
            :height="200"></bar-chart>                      
          <div class="text-xs-center" v-else>
            <v-progress-circular                        
              :size="70"
              :width="7"
              indeterminate
            ></v-progress-circular>          
          </div>
        </div>
      </v-flex>      
  </v-layout>     
    </Responsive> 
  </div>           
    </template>
    <template v-else>
      <span class="display-2" style="margin:auto">{{$t('Pilot.Nmea.NoDataAvailable')}}</span>
    </template>        
  </div> 
</template>
<script lang="ts">
 
import BarChart from '@/components/charts/BarChart'
import Vue from 'vue'
import Component from 'vue-class-component'
import { MapUiState } from '@/models/ui/MapUiState'
import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { dataLimitMode } from '@/models/ui/GraphUiState'
import apiHelpers from '@/utils/api'
import { Watch } from 'vue-property-decorator'
import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import moment from 'moment'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import {chartColor} from '@/utils/autoscale'
import { nextTick } from 'vue/types/umd'
import { yellow } from '../map/MapStyles'
import { SimulationMode } from '@/enum/SimulationMode'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
import { AloDbMissionGlobal, isAloDbMissionGlobalCoverage, isAloDbMissionGlobalFormation, isAloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal'

@Component({
  name: 'SimulationDetailCompareSimulations',
  components: {BarChart},
  props: {
    isleft:Boolean,
    uiid:{
        type: String,
        required: true
    }
  }
})
export default class SimulationDetailCompareSimulations extends Vue {      

  isleft!:boolean
  uiid!:string
  hideGraph = false  

  get selectedUi(){
    return this.isleft?this.simulationState.tabsleft.selected:this.simulationState.tabsright.selected
  } 

  get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }

 get isCoverageSimu(){
    return isAloDbMissionGlobalCoverage(this.missionGlobal)
 }

 get isFormationSimu(){
    return isAloDbMissionGlobalFormation(this.missionGlobal)
 }

 get finishedSimulation() {
  return (this.isCoverageSimu || this.isFormationSimu)?  
             this.$store.myGetters.coverageIterations?.filter(c=> !!c && c.MIG_ID == this.missionGlobal.MIG_ID && c.COV_PROCESSING_STATE == 'finished' && c.COV_PROCESSING_STEP == 'FinalSimulation').sort((s1,s2)=>s1.COV_ITERATION! - s2.COV_ITERATION!)
            :this.missionGlobal.misIdArray.map(id => this.missionVirtualsById[id] ?? null).filter((m:AloDbMissionVirtual) => m?.result?.simulation_state == 'finished' || m?.result?.simulation_state == 'aborted').sort((m1,m2) => m1.VIM_ITERATION! - m2.VIM_ITERATION!)
 }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get simulationState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
  }

  get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

  get infosSimMission() {
    return this.missionVirtualsById[this.bestFitMisId]
  }

  get map_uiid(){
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,'map')
 }

 get mapState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.map_uiid) as MapUiState         
 }

 get bestFitMisId(){
   return this.mapState?.bestFitMisId
 }

 get selectedCoverageId(){
    return this.coverageState.selectedCoverageId
 }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }  


  get allGraphUiState() {                
      return this.$store.myGetters.uistatebyuiid(this.uiid)
  }

  get dataLimit() {
    return this.allGraphUiState.dataLimit
  }
  

  
  created(){      
    this.hideGraph = true    
    this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(this.uiid)
    this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'dataLimit',value:dataLimitMode.ALL})      
  }

  mounted(){
    setTimeout(() => {
      this.hideGraph = false
    }, 100);
  }
  
    @Watch('bestFitMisId')
    onBestFitMisIdChange() {
      this.hideGraph = true
      this.$nextTick(()=>this.hideGraph = this.selectedUi != this.uiid)
    }

    @Watch('selectedCoverageId')
    onSelectedCoverageIdChange() {
      this.hideGraph = true
      this.$nextTick(()=>this.hideGraph = this.selectedUi != this.uiid)
    }
    

    
    @Watch('selectedUi')
    onSelectedUiChange() {
      this.hideGraph = true
      this.$nextTick(()=>this.hideGraph = this.selectedUi != this.uiid)
    }

    onPointClick(index:number) {          
      //@ts-ignore
      if(this.isCoverageSimu || this.isFormationSimu) this.$store.myActions.COVERAGEITERATION_SELECT_DETAIL(this.finishedSimulation.map(s => s.id!)[index])
      else this.$store.myActions.UI_SELECT_MISSION_MAP({id:this.finishedSimulation.map(s => s.id)[index],uiid:this.map_uiid}) 
    }

    get graphType(){return (this.isCoverageSimu || this.isFormationSimu)?['duration','distance','speed','energy','yos','gliders']:['duration','distance','speed','energy','yos']}

    dureeJour(simulation:AloDbMissionVirtual) {
      //@ts-ignore
      const start = (this.isCoverageSimu || this.isFormationSimu)?simulation.missionStartDate:new Date(simulation.param.mission_start_date)
      //@ts-ignore
      const end = (this.isCoverageSimu || this.isFormationSimu)?simulation.missionCurEndDate:new Date(simulation.result.mission_end_date)
      const duree = (end?.getTime() - start?.getTime()) || 0
      return duree / (24 * 60 * 60 * 1000)
    }
   

    get coverage_uiid() {
      return buildCoverageStateId(this.missionGlobal.MIG_ID!,"detail")
    }

    get coverageState() {     
      return this.$store.myGetters.coverageStateByUiid(this.coverage_uiid)
    }
       

    graphData(fieldToShow:string) {            
      const graphDatas = {
        //@ts-ignore
        labels:this.finishedSimulation.map(s => `#${(this.isCoverageSimu || this.isFormationSimu)?s.COV_ITERATION:s.VIM_ITERATION}`),        
        dataDic:{
          //@ts-ignore
          'duration':[...this.finishedSimulation.map(s => this.dureeJour(s).toFixed(2)),0],
          //@ts-ignore
          'distance':[...this.finishedSimulation.map(s => ((this.isCoverageSimu || this.isFormationSimu)?s.distance_traveled:s.result.distance_traveled)?.toFixed(2)),0],
          //@ts-ignore
          'speed':[...this.finishedSimulation.map(s => (((this.isCoverageSimu || this.isFormationSimu)?s.distance_traveled:s.result.distance_traveled) / (this.dureeJour(s) * 24)).toFixed(2) ),0],
          //@ts-ignore
          'energy':[...this.finishedSimulation.map(s => ((this.isCoverageSimu || this.isFormationSimu)?s.energy_available:s.result.energy_available)?.toFixed(2)),0],
          //@ts-ignore
          'yos':[...this.finishedSimulation.map(s => (this.isCoverageSimu || this.isFormationSimu)?s.nbYos:s.result.cycle_number),0],
          'misId':[...this.finishedSimulation.map(s => s.id),0],
          //@ts-ignore
          'gliders':[...this.finishedSimulation.map(s => (this.isCoverageSimu || this.isFormationSimu)?s?.config?.gliders_config?.length:1),0]
        }
      }

      const me = this
                                
      return { 
          labels: graphDatas.labels,          
          datasets: 
          //@ts-ignore
          this.graphType.filter(field => (graphDatas.dataDic[field]?.length ?? 0) > 0 && field == fieldToShow ).map((field,index) => (
            {
              label: this.$t(`Simulation.Graph.${field}`), //`${this.$i18n.locale == "fr"?field.field.libelleFr:field.field.libelleEn} ${field.field.unit?`[${field.field.unit}]`:''}`,                                                        
              maxBarThickness:15,                     
              backgroundColor: (ctx:any) => {                    
                return (graphDatas.dataDic['misId'][ctx.dataIndex]  == ((me.isCoverageSimu || me.isFormationSimu)?me.selectedCoverageId:me.infosSimMission?.id))?'#22b722':(index==0?'#fb8c00':chartColor[index-1])
              },
              borderWidth: 1,
              //@ts-ignore
              data: graphDatas.dataDic[field]
            }))                    
        }      
    }


    // selectGraph(type:string) {      
    //   const name = fields.map(f => `${this.$i18n.locale == 'fr'?f.field.libelleFr:f.field.libelleEn}${f.field.unit?` [${f.field.unit}]`:''}`).join(' - ')
    //   //@ts-ignore
    //   this.$store.myActions.MISSION_NAVTO_DETAIL({cmp:'MissionDetailNmeaGraphics',isleft:!this.isleft,'label':name}).then(() => {
    //     const tabsMission = !this.isleft? this.$store.myGetters.currentDetailMission.tabsleft: this.$store.myGetters.currentDetailMission.tabsright
    //     //on attend que le composant soit créé
    //     this.$nextTick(()=> 
    //       fields.forEach(f => this.$store.myActions.UI_SET_NMEA_GRA_CONFIG({config:f,uiid:tabsMission.selected}))          
    //     )
    //     this.$store.myActions.UI_SET_GRA_DATA({uiid:tabsMission.selected,name:'dataLimit',value:this.dataLimit})
    //   })    
    // }

  }
</script>